import Vue from 'vue';
import {RawLocation, Route, RouteConfig} from 'vue-router';

export const privateRoutes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    meta: {
      secure: true,
    },
    component: (): Promise<{ default: typeof Vue }> => /* webpackChunkName: "home" */ import('../../views/Home.vue'),
  },
  {
    path: '/home/:buildingId',
    name: 'homeWithId',
    meta: {
      secure: true,
    },
    component: (): Promise<{ default: typeof Vue }> => /* webpackChunkName: "home" */ import('../../views/Home.vue'),
  },
  {
    // Ancienne page Supervision : redirigée vers l'onglet correspondant de l'administration (?tab=0|1|2)
    path: '/listLogs',
    name: 'listLogs',
    redirect: (to: Route): RawLocation => {
      const query = {...to.query};
      delete query.tab;
      return {name: 'administration', params: {tab: ['alertes', 'imports', 'relance'][parseInt(to.query.tab as string, 10)] || 'alertes'}, query};
    },
  },
  {
    // :tab = onglet actif (clients, alertes, imports, relance, firmwares) ; sans onglet : accueil
    path: '/administration/:tab?',
    props: true,
    name: 'administration',
    meta: {
      secure: true,
      admin: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import('../../views/admin/administration/Administration.vue'),
  },
  {
    // Ancienne liste des clients : redirigée vers l'onglet Clients de l'administration
    path: '/listClient',
    name: 'listClient',
    redirect: {name: 'administration', params: {tab: 'clients'}},
  },
  {
    path: '/listBuildings/:uid',
    name: 'listBuildings',
    props: true,
    meta: {
      secure: true,
      admin: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import('../../views/admin/buildings/ListBuildings.vue'),
  },
  {
    path: '/createUpdateBuilding/:uid',
    name: 'createUpdateBuilding',
    props: true,
    meta: {
      secure: true,
      admin: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import('../../views/admin/buildings/CreateUpdateBuilding.vue'),
  },
  {
    path: '/listMeters/:buildingId',
    name: 'listMeters',
    props: true,
    meta: {
      secure: true,
      admin: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import('../../views/admin/meters/ListMeters.vue'),
  },
  {
    path: '/multipleMeterEdit/:buildingId',
    name: 'multipleMeterEdit',
    props: true,
    meta: {
      secure: true,
      admin: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import('../../components/meters/MultipleMetersEdit.vue'),
  },
  {
    // :tab = onglet actif (structure, identifications, administration, datalogger) : conservé au rechargement
    path: '/detailMeter/:buildingId/:meterId/:tab?',
    name: 'detailMeter',
    props: true,
    meta: {
      secure: true,
      admin: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import('../../views/admin/meters/DetailMeter.vue'),
  },
];
